export default __webpack_public_path__ + "216a77f6398794f48ddcff695f2ff7f6.png";